import {
  getLockedMyVendorRequestTooltip,
} from "../../utils/myVendorsRequestAccess";

/**
 * Shared click + a11y behavior for locked My Vendors request badges.
 * Keeps stopPropagation so row navigation does not fire when locked.
 */
export function handleMyVendorRequestBadgeClick(event, { disabled, request, onClick }) {
  event.stopPropagation();
  if (disabled) return;
  onClick?.(request);
}

export function getMyVendorRequestBadgeLockProps(request, isLocked, { isVqaOnly = false } = {}) {
  if (!isLocked) {
    return {
      "aria-disabled": undefined,
      title: undefined,
    };
  }
  return {
    "aria-disabled": true,
    title: getLockedMyVendorRequestTooltip(request, { isVqaOnly }),
  };
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
